import { Skeleton, styled } from "@mui/material";

export const StyledSkeleton = styled(Skeleton)`
  &.MuiSkeleton-root {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[300]};
  }
`;
